'use client';
import { useCompanyInfo } from '@/contexts/CompanyInfoContext';
import Head from 'next/head';
import { useEffect } from 'react';

export default function DynamicMetadata() {
  const { companyInfo } = useCompanyInfo();

  useEffect(() => {
    if (companyInfo) {
      // Update document title
      const title = companyInfo.seo?.metaTitle || `${companyInfo.companyName} - IT Services & Consulting`;
      document.title = title;

      // Update meta description
      const description = companyInfo.seo?.metaDescription || companyInfo.businessInfo?.description || 'Leading IT company providing software development, consulting, and training services with modern solutions.';
      
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', description);

      // Update keywords
      if (companyInfo.seo?.keywords?.length) {
        let metaKeywords = document.querySelector('meta[name="keywords"]');
        if (!metaKeywords) {
          metaKeywords = document.createElement('meta');
          metaKeywords.setAttribute('name', 'keywords');
          document.head.appendChild(metaKeywords);
        }
        metaKeywords.setAttribute('content', companyInfo.seo.keywords.join(', '));
      }

      // Update Open Graph tags
      const updateOgTag = (property: string, content: string) => {
        let ogTag = document.querySelector(`meta[property="${property}"]`);
        if (!ogTag) {
          ogTag = document.createElement('meta');
          ogTag.setAttribute('property', property);
          document.head.appendChild(ogTag);
        }
        ogTag.setAttribute('content', content);
      };

      updateOgTag('og:title', title);
      updateOgTag('og:description', description);
      updateOgTag('og:site_name', companyInfo.companyName);

      // Update favicon if available
      if (companyInfo.logo?.favicon) {
        let favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
        if (!favicon) {
          favicon = document.createElement('link');
          favicon.setAttribute('rel', 'icon');
          document.head.appendChild(favicon);
        }
        favicon.href = companyInfo.logo.favicon;
      }
    }
  }, [companyInfo]);

  return null; // This component doesn't render anything visible
}